"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendJSError = exports.getUUID = exports.DEFAULT_PREFIX = void 0;
const uuid_1 = require("uuid");
exports.DEFAULT_PREFIX = 'idPeticion';
var getUUID = function (idFront, prefix, equalSignal) {
    if (idFront === void 0) {
        idFront = '';
    }
    if (prefix === void 0) {
        prefix = exports.DEFAULT_PREFIX;
    }
    if (equalSignal === void 0) {
        equalSignal = true;
    }
    var v1options = {
        node: [0x01, 0x23, 0x45, 0x67, 0x89, 0xab],
        clockseq: 0x1234,
        msecs: new Date().getTime(),
        nsecs: 5678,
    };
    var uuid = (0, uuid_1.v1)(v1options);
    uuid = uuid.replace(/-/g, '');
    uuid = uuid.toUpperCase();
    var res = "".concat(prefix).concat(equalSignal ? '=' : '').concat(idFront).concat(uuid);
    return res;
};
exports.getUUID = getUUID;
// To do this, you can create a SONDA, and then execute sonda.sondaEvent
var sendJSError = function (processName, method, data) {
    try {
        var dataToSend = JSON.stringify(data);
        if (window.IC && window.IC.trackErrorCtz) {
            window.IC.trackErrorCtz(processName, '', method, dataToSend);
        }
    }
    catch (err) {
        console.log('IC is not defined');
    }
};
exports.sendJSError = sendJSError;
//# sourceMappingURL=index.js.map